import { useEffect, useState } from 'react';
import { isSmartPhone, random } from '../../utilities/helper';
import MatchMakingResultMWeb from './index_mWeb';
import MatchMakingResultWeb from './index_web';
import { useLink, useRouteLocation } from 'react-router-stack';
import avatars from '../../constants/avatars';
import { useSelector } from 'react-redux';

const MatchMakingResult = () => {
  const link = useLink();
  const [winnerData, setWinnerData] = useState({} as any);
  const { gameDetails } = useSelector((state: any) => state.minigames);
  const { contest, gameName } = gameDetails;
  const { winningsAmount } = contest;
  const { state = {} }: any = useRouteLocation();
  const { myWinnerUser = {}, opponentWinnerUser = {} } = state;

  useEffect(() => {
    setWinnerData({
      myWinnerUser,
      opponentWinnerUser
    });
  }, []);

  useEffect(() => {
    if (gameName != 'Ludo') return;
    const probability = random(1, 1000);
    if (gameName === 'Tic Tac Toe') {
      if (myWinnerUser.score === opponentWinnerUser.score) {
        setWinnerData({
          myWinnerUser: {
            ...myWinnerUser,
            winner: true,
            winning: winningsAmount / 2
          },
          opponentWinnerUser: {
            ...opponentWinnerUser,
            winner: true,
            winning: winningsAmount / 2
          }
        });
      } else {
        if (myWinnerUser.score === 1) {
          setWinnerData({
            myWinnerUser: {
              ...myWinnerUser,
              score: myWinnerUser.score,
              winner: true,
              winningType: 1,
              winning: winningsAmount
            },
            opponentWinnerUser
          });
        } else {
          setWinnerData({
            myWinnerUser,
            opponentWinnerUser: {
              ...opponentWinnerUser,
              winner: true,
              winningType: 1,
              winning: winningsAmount
            }
          });
        }
      }
    } else {
      if (probability % 2 == 1) {
        setWinnerData({
          myWinnerUser: {
            ...myWinnerUser,
            score: myWinnerUser.score,
            winner: true,
            winningType: 1,
            winning:
              myWinnerUser.score === opponentWinnerUser.score ? winningsAmount / 2 : winningsAmount
          },
          opponentWinnerUser: {
            ...opponentWinnerUser,
            winner: myWinnerUser.score === opponentWinnerUser.score ? true : false,
            winning: myWinnerUser.score === opponentWinnerUser.score ? winningsAmount / 2 : 0
          }
        });
      } else {
        setWinnerData({
          myWinnerUser,
          opponentWinnerUser: {
            ...opponentWinnerUser,
            winner: true,
            winningType: 1,
            winning: winningsAmount,
            score: opponentWinnerUser.score + 5
          }
        });
      }
    }
  }, []);

  const onPressPlayAgain = () => {
    link.push('/match_making');
  };

  const onPressGoBack = () => {
    link.replace('/');
  };

  return (
    <>
      {isSmartPhone ? (
        <MatchMakingResultMWeb
          winnerData={winnerData}
          avatars={avatars}
          onPressGoBack={onPressGoBack}
          onPressPlayAgain={onPressPlayAgain}
          isShowScore={gameName != 'Ludo'}
        />
      ) : (
        <MatchMakingResultWeb
          winnerData={winnerData}
          avatars={avatars}
          onPressGoBack={onPressGoBack}
          onPressPlayAgain={onPressPlayAgain}
          isShowScore={gameName != 'Ludo'}
        />
      )}
    </>
  );
};

export default MatchMakingResult;
